import React from 'react';
import LegalLayout, { LegalSection } from '../../components/LegalLayout';

export default function CharteMentorEN() {
  return (
    <LegalLayout title="Mentor Charter" lastUpdated="January 1, 2025">
      <div style={{ background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
        <p style={{ color: '#ffc107', fontSize: '13px', margin: 0 }}>
          <strong>Information only:</strong> This is a summary translation for information purposes only.
          The French version is the sole legally binding version. In case of discrepancy, the French version shall prevail.
        </p>
      </div>
      <div style={{ background: 'rgba(255,107,107,0.08)', border: '1px solid rgba(255,107,107,0.2)', borderRadius: '10px', padding: '16px', marginBottom: '24px' }}>
        <p style={{ color: '#e8e8e8', fontSize: '13px', margin: 0 }}>
          <strong>Liability disclaimer:</strong> Kurso mentors are volunteer or independent facilitators. Their advice does not in any way replace the opinion of a qualified professional (doctor, lawyer, psychologist, therapist, accountant, financial advisor, or any other certified expert in their field). Kurso acts solely as a matchmaking platform and disclaims all liability for advice provided by mentors.
        </p>
      </div>
      <LegalSection title="1. Role of mentors">
        <p>A Kurso mentor is a volunteer or independent professional who offers sessions to other platform users to share knowledge, experience, and guidance in their field of expertise.</p>
        <p>Mentors are <strong>not</strong> professional consultants, therapists, or certified advisors — unless they separately hold such qualifications. Their role is to share experience, not to provide professional advice.</p>
      </LegalSection>
      <LegalSection title="2. What mentors can do">
        <ul>
          <li>Share personal and professional experience on their topics</li>
          <li>Facilitate learning and skills development</li>
          <li>Offer free or paid sessions via the Kurso platform</li>
          <li>Suggest resources, tools, and learning paths</li>
          <li>Provide constructive, encouraging feedback</li>
        </ul>
      </LegalSection>
      <LegalSection title="3. What mentors must not do">
        <ul>
          <li>Present themselves as licensed professionals (doctor, lawyer, accountant, etc.) without holding the relevant qualifications</li>
          <li>Make diagnoses, prescribe treatments, or give legal or financial advice</li>
          <li>Share confidential, illegal, or misleading information</li>
          <li>Engage in any commercial solicitation outside the Kurso platform</li>
          <li>Discriminate, harass, or behave inappropriately toward learners</li>
        </ul>
      </LegalSection>
      <LegalSection title="4. Code of conduct">
        <p>All Kurso mentors commit to:</p>
        <ul>
          <li>Responding to booking requests within 48 hours</li>
          <li>Respecting the session time slot and duration</li>
          <li>Maintaining a respectful, professional, and inclusive attitude</li>
          <li>Keeping confidential any personal information shared by learners</li>
          <li>Promptly reporting any inappropriate behaviour by learners</li>
        </ul>
      </LegalSection>
      <LegalSection title="5. Liability">
        <p>Kurso acts solely as a matchmaking platform between mentors and learners. Kurso does not verify the qualifications of mentors and assumes no liability for the content of exchanges, the quality of advice given, or any consequences arising from the implementation of such advice.</p>
        <p>Mentors are solely responsible for the content of their sessions. By accepting this Charter, each mentor acknowledges full personal responsibility for their conduct on the platform.</p>
      </LegalSection>
      <LegalSection title="6. Suspension and removal">
        <p>Kurso reserves the right to suspend or permanently remove any mentor who violates this Charter, receives multiple negative reports, or engages in conduct contrary to the platform's values, without prior notice or compensation.</p>
      </LegalSection>
    </LegalLayout>
  );
}
